import { BasicsClass } from "@/common/BasicsClass";
import { Util } from "@/common/util";

import { CommonApi } from "../common";

export class AccountListAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getAccountList', {
      url: '/admin/marketPool/accountIndex',
      name: 'list',
      label: '列表'
    }],
    // ['exportExcelSAccountListList', {
    //   url: '/admin/seller_blacklist/exportList',
    //   name: 'export-excel',
    //   label: '导出'
    // }],
    ['addAccountList', {
      url: '/admin/marketPool/addAccount',
      name: 'add-account-list',
      label: '添加账号'
    }],
    ['editAccountList', {
      url: '/admin/marketPool/editAccount',
      name: 'edit-account-list',
      label: '编辑账号'
    }],
    ['deleteAccountList', {
      url: '/admin/marketPool/delAccount',
      name: 'delete-account-list',
      label: '删除账号'
    }],


  ])
  // api 方法
  // 账号列表
  public getAccountList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {

    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getAccountList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


  // 导出账号列表
  // public exportExcelSAccountListList(
  //   params: any,
  //   successCb: Function,
  //   failCb: Function,
  //   showLoading: boolean = false
  // ) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('exportExcelSAccountListList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 添加账号
  public addAccountList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addAccountList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 编辑账号
  public editAccountList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('editAccountList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 删除账号
  public deleteAccountList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('deleteAccountList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

}
